module.exports = __webpack_public_path__ + "img/logo.d6c02df1.png";